import React, { useState } from 'react';
import styles from './PrequalificationStep.module.css';
import sharedStyles from './SchedulingFlow.module.css';
import AxisLogo from './SVGs/AxisLogo';

interface MedicaidQuestionStepProps {
  onBack: () => void;
  onProceed: (hasMedicaid: boolean) => void;
}

const MedicaidQuestionStep: React.FC<MedicaidQuestionStepProps> = ({ 
  onBack, 
  onProceed
}) => {
  const [hasMedicaid, setHasMedicaid] = useState<boolean | null>(null);

  const handleChange = (value: boolean) => {
    setHasMedicaid(value);
  };

  const handleSubmit = () => {
    if (hasMedicaid !== null) {
      onProceed(hasMedicaid);
    }
  };

  const canProceed = hasMedicaid !== null;

  return (
    <div className={styles.preQualificationAssessment}>
      {/* Header/Navigation */}
      <div className={styles.navBar}>
        <AxisLogo variant="white" size="extra-large" className={styles.navLogo} onClick={() => window.open('https://www.axismh.com/', '_blank')} style={{ cursor: 'pointer' }} />
        <span className={styles.navPhone}>(720) 400-7025</span>
        <div className={styles.navLinks}>
          <button className={styles.navLink} onClick={() => window.location.reload()}>HOME</button>
          <a
            href="https://go.axismh.com/spravato-prep"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.navLink}
            title="Spravato Preparation Tips & Help"
          >
            Help
          </a>
        </div>
      </div>

      {/* Main Content */}
      <div className={styles.mainContent}>
        <h1 className={styles.title}>Insurance Information</h1>
        <p className={styles.subtitle}>
          Please let us know about your insurance coverage for your Spravato appointment.
        </p>

        <div className={styles.card}>
          <div className={styles.sectionTitle}>Medicaid Insurance</div>

          <div className={styles.questionsList}>
            <div className={styles.questionItem}>
              <div className={styles.questionText}>
                Do you have Medicaid insurance?
              </div>
              <div className={styles.radioGroup}>
                <label className={styles.radioOption}>
                  <input
                    type="radio"
                    name="medicaid-question"
                    value="Yes"
                    checked={hasMedicaid === true}
                    onChange={() => handleChange(true)}
                    className={styles.radioInput}
                  />
                  <span className={styles.radioLabel}>Yes</span>
                </label>
                <label className={styles.radioOption}>
                  <input
                    type="radio"
                    name="medicaid-question"
                    value="No"
                    checked={hasMedicaid === false}
                    onChange={() => handleChange(false)}
                    className={styles.radioInput}
                  />
                  <span className={styles.radioLabel}>No</span>
                </label>
              </div>
            </div>
          </div>

          <div className={sharedStyles.formActions}>
            <button
              onClick={handleSubmit}
              className={sharedStyles.submitButton}
              disabled={!canProceed}
            >
              Continue
            </button>
          </div>
        </div>

        <button className={styles.backButton} onClick={onBack}>
          ← Back
        </button>
      </div>
    </div>
  );
};

export default MedicaidQuestionStep;

